import Link from 'next/link';
import Router, { useRouter } from 'next/router';
import { ChangeEvent, FormEvent, useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../contexts/Auth/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import { GetServerSideProps } from "next";
import { parseCookies } from 'nookies';
import Image from 'next/image';
import logo from '../../public/logo-horizontal-azul.png'
import { Button } from '../../components/Button';
import { useApi } from '../../hooks/useApi';
import { BiArrowBack } from 'react-icons/bi';

const RecuperarSenha = () => {
    const api = useApi();
    const [email, setEmail] = useState('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const router = useRouter();

    const handleEmail = (event: ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    }

    const recuperarSenha = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setCarregando(true);
        if (email !== "") {
            const resposta = await api.recuperarSenha(email);
            if (resposta.erro === "") {
                toast.success("Email enviado com sucesso.")
            } else {
                toast.error(resposta.erro);
            }
        }
        setCarregando(false);
        setEmail("");
    }

    return (
        <main className='min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8'>
            <div className="max-w-md w-full space-y-8">
                <div className='cursor-pointer mx-auto w-48'>
                    <Image className="" src={logo} alt="logo " />
                </div>
                <div className='flex flex-col text-center'>
                    <span className='text-gray-600 dark:text-gray-200 font-bold text-3xl'>Recuperar senha</span>
                    <p className="m-0 p-0 text-sm text-gray-600 dark:text-gray-200 text-muted">
                        Digite o endereço de e-mail da sua conta e enviaremos um link para redefinir sua senha.
                    </p>
                </div>
                <form className='mt-4 space-y-6' onSubmit={recuperarSenha}>
                    <div className='form-floating'>
                        <input
                            value={email}
                            type="email"
                            required
                            className="form-input"
                            id="email"
                            onChange={handleEmail}
                            placeholder="name@example.com" />
                    </div>
                    <div className='flex flex-col justify-center items-center gap-3'>
                        <Button disabled={carregando} width='w-full'>Enviar link</Button>
                    </div>
                </form>
                <div className='flex justify-center text-center'>
                    <Button
                        textColor='text-gray-600 dark:text-gray-200'
                        styleButton='bg-transparent border dark:border-rifaweb-medium dark:text-gray-200'
                        width='w-fit'
                        onClick={() => router.push('/login')}
                    >
                        <BiArrowBack />
                        Voltar ao login
                    </Button>
                </div>
            </div>
        </main>
    )
}

export default RecuperarSenha;

export const getServerSideProps: GetServerSideProps = async (context) => {
    const { 'rifaAuthToken': token } = parseCookies(context);
    if (token) {
        return {
            redirect: {
                destination: '/admin',
                permanent: false
            }
        }
    }

    return {
        props: {}
    }

}